(() => {
  if (customElements.get('dm-workflow-tabs')) return;

  class DairyMindWorkflowTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-workflow-tab]')];
      this.panels = [...this.querySelectorAll('[data-workflow-panel]')];
      this.onClick = (event) => {
        const tab = event.target.closest('[data-workflow-tab]');
        if (this.tabs.includes(tab)) this.activate(tab.dataset.workflowTab);
      };
      this.onKeydown = (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(this.tabs[next].dataset.workflowTab);
        this.tabs[next].focus();
      };
      this.onBlockSelect = (event) => {
        const panel = this.panels.find((item) =>
          item.dataset.workflowPanel === event.detail?.blockId || item.contains(event.target)
        );
        if (panel) this.activate(panel.dataset.workflowPanel);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      if (this.tabs.length) this.activate(this.tabs[0].dataset.workflowTab);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    activate(id) {
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.workflowTab === id;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.workflowPanel !== id;
      });
    }
  }

  customElements.define('dm-workflow-tabs', DairyMindWorkflowTabs);
})();

